import { useEffect, useState } from "react";
import axios from "axios";
import { Link2, FileText, ExternalLink } from "lucide-react";
import BackToMore from "../components/BackToMore";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Links() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    axios
      .get(`${API}/links`)
      .then((r) => setItems(r.data))
      .catch(() => {});
  }, []);

  return (
    <div className="p-4 pb-10" data-testid="links-page">
      <BackToMore />
      <h2
        className="font-extrabold mb-1"
        style={{ color: "#092936", fontSize: 22 }}
      >
        Links
      </h2>

      <div className="mt-5">
        <div className="flex items-center gap-2.5 mb-2.5">
          <div
            className="rounded-[10px] flex items-center justify-center"
            style={{ width: 40, height: 40, background: "#145261" }}
          >
            <Link2 size={20} color="#FFFFFF" strokeWidth={2.2} />
          </div>
          <h3
            className="font-extrabold"
            style={{ color: "#092936", fontSize: 16 }}
          >
            Quick Access
          </h3>
        </div>

        {items.map((r, idx) => {
          const hasUrl = r.url && r.url.trim().length > 0;
          const inner = (
            <>
              <FileText
                size={18}
                color="#145261"
                className="flex-shrink-0 mt-0.5"
              />
              <div className="flex-1">
                <p
                  className="font-semibold"
                  style={{ color: "#092936", fontSize: 14 }}
                >
                  {r.title}
                </p>
                {r.description && (
                  <p
                    className="mt-1"
                    style={{
                      color: "#5A6A72",
                      fontSize: 12,
                      lineHeight: "17px",
                    }}
                  >
                    {r.description}
                  </p>
                )}
              </div>
              <ExternalLink
                size={16}
                color="#5A6A72"
                className="flex-shrink-0 mt-0.5"
              />
            </>
          );
          return hasUrl ? (
            <a
              key={r.id}
              href={r.url}
              data-testid={`link-${idx}`}
              className="flex items-start gap-2.5 bg-white p-3 rounded-[10px] mb-2 border"
              style={{ borderColor: "rgba(20,82,97,0.15)" }}
            >
              {inner}
            </a>
          ) : (
            <div
              key={r.id}
              data-testid={`link-${idx}`}
              className="flex items-start gap-2.5 bg-white p-3 rounded-[10px] mb-2 border"
              style={{ borderColor: "rgba(20,82,97,0.15)" }}
            >
              {inner}
            </div>
          );
        })}
      </div>
    </div>
  );
}
